import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/atoms/texts/label';

const STEP_FLOW = [
    'PERSONAL_INFO',
    'DOCUMENTS',
    'CURRENT_MISSION',
    'SYNAPSE_VALIDATION',
    'ADMINISTRATIVE_INFO',
    'CONTRACT_GENERATION',
    'OFFICE_APPOINTMENT',
    'COMPLETE',
];

const ProgressCandidate = ({ step, hasLabel = true, className }) => {
    const [t] = useTranslation('global');
    const stepIndex = STEP_FLOW.indexOf(step);
    const currentStep = stepIndex >= 0 ? stepIndex + 1 : 1;

    return (
        <div className={`flex items-center gap-firstDegree `}>
            <div className={`flex gap-1 min-w-[160px] ${className}`}>
                {STEP_FLOW.map((flowStep, index) => (
                    <div
                        key={flowStep}
                        className={[
                            'h-1.5 min-w-6 grow rounded-full',
                            index < currentStep ? 'bg-primary' : 'bg-medium',
                        ].join(' ')}
                    />
                ))}
            </div>
            {hasLabel && (
                <Label size="small" color="grey" className="whitespace-nowrap w-auto shrink-0 ">
                    {t('management.onboarding.candidate.stepProgress', { current: currentStep, total: STEP_FLOW.length })}
                </Label>
            )}
        </div>
    );
};

export default ProgressCandidate;
